import InputCompleteWorks from './InputCompleteWorks.vue'

export { InputCompleteWorks }
